module.exports = __webpack_public_path__ + "static/media/person_nus.35f385d5.png";